import React from "react"
import { Box, Typography, Divider, Grid } from "@mui/material"
import { useTheme } from "@mui/system"
import AppTextField from "components/StyledComponents/AppTextField"
import ImageUploadField from "components/FileUpload/ImageUploadField"
import { useDispatch, useSelector } from "react-redux"
import { uploadCMSMediaAction } from "redux/superAdmin/actions"
import GroupsIcon from "@mui/icons-material/Groups"

const SectionHeader = ({ children }) => {
  const theme = useTheme()
  return (
    <Box sx={{ mb: 2, mt: 4 }}>
      <Typography
        variant="body2Regular"
        sx={{
          color: theme.palette.text.secondary,
          opacity: 0.6,
          textTransform: "uppercase",
          letterSpacing: "0.08em"
        }}>
        {children}
      </Typography>
      <Divider sx={{ borderColor: theme.palette.background.main, mt: 1 }} />
    </Box>
  )
}

const RestaurantGroupFormContent = ({
  formik,
  isEdit,
  iconFile,
  setIconFile,
  setIconMediaId,
  setIconUploading
}) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const { cmsRestaurantGroupDetail } = useSelector((store) => store?.superAdmin ?? {})

  const handleIconChange = (file) => {
    setIconFile(file)
    setIconUploading(true)
    const formData = new FormData()
    formData.append("media", file)
    formData.append("media_type", "IMAGE")
    formData.append("content_type", file.type || "image/png")
    dispatch(
      uploadCMSMediaAction({
        payload: formData,
        onSuccess: (data) => {
          setIconMediaId(data?.id || data?.media_id || null)
          setIconUploading(false)
        }
      })
    )
  }

  return (
    <Box sx={{ mt: 2, pb: 3 }}>
      <SectionHeader>General Info</SectionHeader>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <AppTextField
            id="name"
            name="name"
            fullWidth
            label="Group Name"
            isUpperCase={false}
            isRequired
            placeholder="Enter group name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <AppTextField
            id="email"
            name="email"
            fullWidth
            label="Email"
            isUpperCase={true}
            isRequired
            placeholder="contact@restaurant-group.com"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </Grid>
        {isEdit && cmsRestaurantGroupDetail?.domain_name && (
          <Grid item xs={12} md={4}>
            <AppTextField
              id="domain_name"
              name="domain_name"
              fullWidth
              label="Domain Name"
              disabled
              isUpperCase={true}
              value={cmsRestaurantGroupDetail.domain_name}
            />
          </Grid>
        )}
      </Grid>

      {isEdit && (
        <>
          <SectionHeader>Restaurants in Group</SectionHeader>
          <Box
            sx={{
              border: `1px solid ${theme.palette.aqua.main}30`,
              borderRadius: "8px",
              px: 2,
              py: 1.5,
              display: "inline-flex",
              alignItems: "center",
              gap: 1.5
            }}>
            <GroupsIcon sx={{ color: theme.palette.aqua.main }} />
            <Typography variant="body1Regular">
              {cmsRestaurantGroupDetail?.restaurant_count ?? 0} restaurant
              {(cmsRestaurantGroupDetail?.restaurant_count ?? 0) !== 1 ? "s" : ""} in this group
            </Typography>
          </Box>
        </>
      )}

      <SectionHeader>Icon / Media</SectionHeader>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ImageUploadField
            label="Group Icon"
            placeholder="Upload icon (PNG, JPG, SVG)"
            value={iconFile}
            onChange={handleIconChange}
            onDelete={() => {
              setIconFile(null)
              setIconMediaId(null)
            }}
            isVariant
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default RestaurantGroupFormContent
